import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import AccessDenied from "pages/AccessDenied";
import DepartmentManagerHub from './pages/department-management';
import InventoryManagement from './pages/inventory-management';
import Login from './pages/login';
import UserManagement from './pages/user-management';
import ExecutiveDashboard from './pages/executive-dashboard';
import StaffWorkflowCenter from './pages/staff-workflow-center';
import FinancialAnalyticsDashboard from './pages/financial-analytics-dashboard';
import FinancialReportsCenter from './pages/financial-reports-center';
import BudgetManagement from './pages/budget-managemenent';
import ProfileSettings from './pages/profile-settings';
import { PERMISSIONS } from './constants/roles';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        
        {/* Protected Routes with Permissions */}
        
        {/* Executive Dashboard - Executives and Admins only */}
        <Route 
          path="/executive-dashboard" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.FINANCIAL_VIEW}>
              <ExecutiveDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Department Manager Hub - Managers and above */}
        <Route 
          path="/department-manager-hub" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.DEPARTMENT_MANAGE}>
              <DepartmentManagerHub />
            </ProtectedRoute>
          } 
        />
        
        {/* Department Management - Alternative route for same page */}
        <Route 
          path="/department-management" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.DEPARTMENT_MANAGE}>
              <DepartmentManagerHub />
            </ProtectedRoute>
          } 
        />
        
        {/* Staff Workflow Center - All authenticated users */}
        <Route 
          path="/staff-workflow-center" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.TASKS_VIEW}>
              <StaffWorkflowCenter />
            </ProtectedRoute>
          } 
        />
        
        {/* Inventory Management - All except viewers */}
        <Route 
          path="/inventory-management" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.INVENTORY_VIEW}>
              <InventoryManagement />
            </ProtectedRoute>
          } 
        />
        
        {/* User Management - Admins only */}
        <Route 
          path="/user-management" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.USERS_VIEW}>
              <UserManagement />
            </ProtectedRoute>
          } 
        />
        
        {/* Financial Analytics - Executives, Managers, and Admins */}
        <Route 
          path="/financial-analytics-dashboard" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.FINANCIAL_VIEW}>
              <FinancialAnalyticsDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Financial Reports Center - Those with report view permission */}
        <Route 
          path="/financial-reports-center" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.REPORTS_VIEW}>
              <FinancialReportsCenter />
            </ProtectedRoute>
          } 
        />
        
        {/* Budget Management - Those with budget view permission */}
        <Route 
          path="/budget-management" 
          element={
            <ProtectedRoute requiredPermission={PERMISSIONS.BUDGET_VIEW}>
              <BudgetManagement />
            </ProtectedRoute>
          } 
        />
        
        {/* Profile Settings - All authenticated users */}
        <Route 
          path="/profile-settings" 
          element={
            <ProtectedRoute>
              <ProfileSettings />
            </ProtectedRoute>
          } 
        />
        
        {/* Access Denied Page */}
        <Route path="/access-denied" element={<AccessDenied />} />
        
        {/* 404 Not Found */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
